import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormService } from '../../../../services/form.service';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../../services/navigation.service';
import { FormGroup } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';

@Component({
  selector: 'app-save-draft-button',
  templateUrl: './save-draft-button.component.html',
  styleUrls: ['./save-draft-button.component.scss']
})
export class SaveDraftButtonComponent implements OnInit, OnDestroy {
  usanFormType!: string;
  private usanFormTypeSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;
  private formValueChange: boolean = false;

  constructor(protected navigationService: NavigationService, protected formService: FormService, private alertService: AlertsService, private responsive: BreakpointObserver) {
    this.usanFormTypeSubscription = this.navigationService.getUsanFormTypeUpdate().subscribe(
      formType => {
        this.usanFormType = formType.value;
      });
    this.usanFormType = this.navigationService.getUsanFormTypeValue();
  }
  
  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.usanFormTypeSubscription.unsubscribe();
    this.sizeChangeSubscription.unsubscribe();
  }

  isSaveEnabled(): boolean {
    return this.formValueChange;
  }

  public saveDraft() {
    if(!this.currentForm.get('formType')?.value && this.usanFormType) {
      this.formService.updateUsanFormValue('formType', this.usanFormType);
    }
    this.formService.createOrSaveCase().subscribe(
      result => {
        if(result) {
          this.alertService.displaySuccess("Saved.");
        } else {
          this.alertService.displayError("There was an error while trying to save. Please try again.");
        }
      },
      error => {
        console.error(error);
        this.alertService.displayError("There was an error while trying to save. Please try again.");
      });
  }

  get isMobileDeviceSize() : boolean {
    return this.mobileDeviceSize;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
